import _ from 'lodash'
import i18n from '../i18n'

const baseUrl = process.env.REACT_APP_BASE_URL

/**
 * GET a public API route (not under /admin).
 */
export async function fetchPublicApi(path) {
  const normalizedPath = _.startsWith(path, '/') ? path : `/${path}`
  const response = await fetch(`${baseUrl}${normalizedPath}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Accept-Language': i18n.language || 'en',
    },
  })
  return response.json()
}

export async function fetchCarFilters() {
  const response = await fetchPublicApi('/cars/filters')
  if (response?.success && _.isArray(response.data)) {
    return response.data
  }
  return []
}
